import { Component, inject, OnInit } from '@angular/core';
import { KeyValueChanges, KeyValueDiffer, KeyValueDiffers, DoCheck } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { MessageService } from '../message.service';
import { ProcessDefinition } from '../process-definition';
import { RepoService } from '../repo.service';

@Component({
    selector: 'app-proc-def-detail',
    templateUrl: './proc-def-detail.component.html',
    styleUrls: ['./proc-def-detail.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class ProcDefDetailComponent implements OnInit, DoCheck {

  html: SafeHtml;
  procDefId: string;
  procDef: ProcessDefinition;
  procDefDiffer: KeyValueDiffer<string, any>;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private repoService: RepoService = inject(RepoService);
  private messageService: MessageService = inject(MessageService);
  private router: Router = inject(Router);
  private sanitizer: DomSanitizer = inject(DomSanitizer);
  private differs: KeyValueDiffers = inject(KeyValueDiffers);

  ngOnInit(): void {
    this.messageService.set(`Viewing process definition...`);
    this.procDefId = this.route.snapshot.paramMap.get('id');
    this.messageService.set(`Viewing process definition ${this.procDefId}...`);
    this.repoService.getProcessDefinition(this.procDefId)
        .subscribe(procDef => {
          this.procDef = procDef;
          // proc def has to be read in several chunks so use Differ to detect changes
          this.procDefDiffer = this.differs.find(this.procDef).create();
        });
  }

  procDefResourceChanged(changes: KeyValueChanges<string, any>) {
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.procDef.resourceContent.diagram);
  }

  ngDoCheck(): void {
    if (this.procDef && this.procDef.resourceContent && this.procDef.resourceContent.diagram) {
      const changes = this.procDefDiffer.diff(this.procDef.resourceContent);
      if (changes) {
        this.procDefResourceChanged(changes);
      }
    }
  }
}
